import React from "react";
import { Col, Card } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import EmptyState from "./EmptyState";

const TopGroups = ({ data = [] }) => {
  const hasData = data?.length > 0;

  return (
    <Col md={6} className="mb-4">
      <Card style={{ minHeight: "340px" }}>
        <Card.Body>
          <h6 className="fw-bold text-muted">
            {`Top Groups | Average Monthly Victims `}
          </h6>
          {!hasData ? (
            <EmptyState title="No groups found" />
          ) : (
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                data={data}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="group_name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar
                  dataKey="record_count"
                  fill="#e74c3c"
                  name={"Average Victims"}
                />
              </BarChart>
            </ResponsiveContainer>
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default TopGroups;
